import React from "react";
import { Link } from "react-router";
import axios from "axios";
import ChapterProgress from "../../components/ChapterProgress";

export default class competenceprofilesResume extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            competenceprofile: false,
            competenceprofileData: false
        };

        this.updateElementState = this.updateElementState.bind(this);
        this.handleSubmitPrevious = this.handleSubmitPrevious.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    updateElementState(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmitPrevious(e) {
        e.preventDefault();
        this.props.router.push("/competenceprofiles/edit/" + this.props.params.itemID + "/bundles");
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.router.push("/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments");
    }

    componentDidMount() {
        axios
            .all([axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/"), axios.get("/v1/competenceprofiles/" + this.props.params.itemID + "/end_terms/")])
            .then(
                axios.spread((cp, cpData) => {
                    this.setState({
                        competenceprofile: cp.data,
                        competenceprofileData: cpData.data
                    });
                })
            )
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        let resumeRows = [];
        if (!this.state.competenceprofileData) {
            return (
                <div>
                    <div className="section-top">
                        <h1>Ophalen van alle details...</h1>
                    </div>
                </div>
            );
        } else {
            this.state.competenceprofileData.forEach((et) => {
                // Show endterm title
                resumeRows.push(
                    <h2 key={"et-" + et.uuid}>
                        Eindterm: <strong>{et.name}</strong>
                    </h2>
                );

                et.competences.forEach((comp) => {
                    // Show competence title
                    resumeRows.push(
                        <h3 key={"comp-" + et.uuid + "-" + comp.uuid}>
                            Competentie: <strong>{comp.name}</strong>
                        </h3>
                    );

                    // Check for bundles and render these first
                    let bundles = [];
                    comp.measurements.forEach((meas) => {
                        if (meas.bundle !== null && bundles.find((b) => b.uuid == meas.bundle.uuid) === undefined) {
                            bundles = [
                                ...bundles,
                                {
                                    uuid: meas.bundle.uuid,
                                    name: meas.bundle.name
                                }
                            ];
                        }
                    });

                    // Show all the bundles within this competence
                    bundles.forEach((bundle) => {
                        let measRows = [];
                        comp.measurements.forEach((meas) => {
                            if (meas.bundle !== null && meas.bundle.uuid === bundle.uuid) {
                                let description = "Toetsing: ";
                                if (meas.type === "knowledge") {
                                    description = "Kennis: ";
                                }
                                if (meas.type === "knowledge-exam") {
                                    description = "Theorietoets: ";
                                }
                                if (meas.type === "elearning") {
                                    description = "E-learning: ";
                                }
                                measRows.push(
                                    <li key={comp.uuid + meas.uuid}>
                                        {description} <strong>{meas.name}</strong>
                                    </li>
                                );
                            }
                        });

                        if (measRows.length > 0) {
                            resumeRows.push(
                                <div key={"bundle-" + et.uuid + "-" + comp.uuid + "-" + bundle.uuid}>
                                    <h4>
                                        Toetsbundel: <strong>{bundle.name}</strong>
                                    </h4>
                                    <ul>{measRows}</ul>
                                </div>
                            );
                        }
                    });

                    let measRows = [];
                    let rowTitle = false;
                    comp.measurements.forEach((meas) => {
                        if (meas.bundle === null) {
                            if (rowTitle === false) {
                                resumeRows.push(<h4 key={"bundle-" + et.uuid + "-" + comp.uuid + "-unbundled"}>Ongebundeld:</h4>);
                                rowTitle = true;
                            }
                            let description = "Toetsing: ";
                            if (meas.type === "knowledge") {
                                description = "Kennis: ";
                            }
                            if (meas.type === "knowledge-exam") {
                                description = "Theorietoets: ";
                            }
                            if (meas.type === "elearning") {
                                description = "E-learning: ";
                            }

                            measRows.push(
                                <li key={meas.uuid}>
                                    {description}
                                    <strong>{meas.name}</strong>
                                </li>
                            );
                        }
                    });

                    if (measRows.length > 0) {
                        resumeRows.push(<ul key={"list" + et.uuid + "-" + comp.uuid + "-nobundle"}>{measRows}</ul>);
                    }
                });
            });
        }

        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/competenceprofiles"}>Competentieprofielen</Link>
                    </div>
                    <h1>
                        <strong>{this.state.competenceprofile.name}</strong>
                    </h1>

                    <ChapterProgress
                        chapters={[
                            { title: "Algemene gegevens", link: "/competenceprofiles/edit/" + this.props.params.itemID },
                            { title: "Competenties", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/competences" },
                            { title: "Toetsingen", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurements" },
                            { title: "Toetsbundels", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/bundles" },
                            { title: "Samenvatting", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/resume" },
                            { title: "Standaard toetsmomenten", link: "/competenceprofiles/edit/" + this.props.params.itemID + "/measurementmoments" }
                        ]}
                        isDirty={false}
                        activeChapter={5}
                        {...this.props}
                    />
                </div>

                {resumeRows.length == 0 ? (
                    <div className="alert alert-danger">Er zijn nog geen competenties, toetsingen en/of toetsbundels gekozen, ga terug naar de vorige stap.</div>
                ) : (
                    ""
                )}

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="cp-resume">{resumeRows}</div>

                    <div className="form-group text-center">
                        <button className="btn btn-light" type="button" onClick={this.handleSubmitPrevious}>
                            Terug naar toetsbundels
                        </button>
                        <button className="btn btn-primary" onClick={this.handleSubmit}>
                            Naar de standaard toetsmomenten
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}
